export const formatNumber = (num?: number) => {
  if (!num) return '0'
  return num.toLocaleString()
}
